/** @format */
import { logger } from '@toucan/client/global/application/';

export const getRiskifiedSessionId = (params?: {
    callRoute: string;
}): string => {
    if (typeof window.RISKX === 'undefined') {
        logger.error(
            new Error(
                'window.RISKX undefined when trying to get Riskified session ID. Called from route: ' +
                    params?.callRoute
            )
        );
    }

    return window.RISKX?.getSessionId() ?? '';
};
